import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRequestDecorator } from '../core/triggerbee/http.request.decorator';
import { TriggerbeeApi } from '../core/triggerbee/triggerbee-api.enum';
import { AgentHistoryListResponse, AgentHistoryTranscript } from './agent-history.model';

// User-facing history reads via the Gateway. Site + user are resolved server-side from the session
// (the decorator's X-Target-Site-Id header names the site); ownership is enforced by the Agents API.
@Injectable({ providedIn: 'root' })
export class AgentHistoryService {
  private readonly http = inject(HttpRequestDecorator);

  list(pageSize: number, continuationToken?: string): Observable<AgentHistoryListResponse> {
    const params: Record<string, string | number> = { pageSize };
    if (continuationToken) {
      params['continuationToken'] = continuationToken;
    }
    return this.http.get(this.resource('agents/conversations'), params);
  }

  getTranscript(conversationId: string): Observable<AgentHistoryTranscript> {
    return this.http.get(this.resource(`agents/conversations/${encodeURIComponent(conversationId)}`), {});
  }

  private resource(subResource: string): string {
    return `${this.http.getBaseUrl(TriggerbeeApi.Gateway)}/${subResource}`;
  }
}
